// Danish

jQuery.extend( jQuery.fn.pickadate.defaults, {
    monthsFull: [ 'Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December' ],
    monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
    weekdaysFull: [ 'Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag' ],
    weekdaysShort: [ 'Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør' ],
    today: 'I dag',
    clear: 'Ryd dato',
    close: 'Luk',
    firstDay: 1,
    format: 'dd.mm.yyyy',
    formatSubmit: 'dd.mm.yyyy',
    min: [2007, 1, 1],
    max: +366
    
});